import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { HighlightedBenefits } from '@shared-ui/lodging-property-offers';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const HighlightedBenefitsWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <Experiment name="PDP_PCC_Value_Props_LCP_Performance_Improvement">
    <ExperimentControl />
    <ExperimentVariant bucket={1}>
      <HighlightedBenefits inputs={inputs} skipSsr={false} />
    </ExperimentVariant>
    <ExperimentVariant bucket={2}>
      <HighlightedBenefits inputs={inputs} skipSsr={true} />
    </ExperimentVariant>
  </Experiment>
);

HighlightedBenefitsWrapper.displayName = 'SharedUiHighlightedBenefitsWrapper';
export const SharedUiHighlightedBenefitsWrapper = withSharedUiPropertyOffers(HighlightedBenefitsWrapper);
